import { render, staticRenderFns } from "./NotificationClassWithDelays.vue?vue&type=template&id=74fdf648&scoped=true"
import script from "./NotificationClassWithDelays.vue?vue&type=script&lang=js"
export * from "./NotificationClassWithDelays.vue?vue&type=script&lang=js"
import style0 from "./NotificationClassWithDelays.vue?vue&type=style&index=0&id=74fdf648&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fdf648",
  null
  
)

export default component.exports